// Client-Side Form Validation - Part 1 - Form Checking
//
// Based on:
// https://developer.mozilla.org/en-US/docs/Learn/Forms/Form_validation
// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html

function checkForm(form_id, revalidate) {
    if (revalidate) {
        var checkClass = "validated";
    } else {
        var checkClass = "validate";
    }
    const form = document.getElementById(form_id);
    const fields = form.getElementsByClassName(checkClass);
    for (let i = 0; i < fields.length; ++i) {
        let field = fields[i],
            field_id = field.id,
            field_name = field.name,
            field_error = document.querySelector('#' + field_id + ' ~ .field-error'),
            compareField = '';

        if (field_id == 'passwordconfirm') {
            compareField = document.getElementById('password');
        }
        if (field_id == 'newpasswordconfirm') {
            compareField = document.getElementById('newpassword');
        }

        if (revalidate == '1') {
            if (field.validity.valid) {
                field_error.textContent = '';
                field_error.className = 'field-error';
            } else {
                showError(field, field_error, '', form_id, field_name);
            }
        } else {
            form.addEventListener('submit', function(event) {
                if (formCheckOff != '1') {
                    field.classList.add('validated');
                    let field_invalid = '';
                    if (!field.validity.valid) {
                        showError(field, field_error, '', form_id, field_name);
                        event.preventDefault();
                        field_invalid = document.querySelector('#' + form_id + ' .validated:invalid');
                    }
                    if (compareField != '') {
                        var register = document.getElementById('register');

                        if ((!register || register.checked) && compareField.value != field.value) {
                            showError(field, field_error, 'passwordConfirmFails', form_id, field_name);
                            event.preventDefault();
                            field_invalid = field;
                        }
                    }
                    if (field_invalid) {
                        field_invalid.focus();
                    }
                }
            });

            form.addEventListener('submit', function() {
                var inputListeningFn = function() {
                    field.classList.add('validated');
                    if (field.validity.valid) {
                        field_error.textContent = '';
                        field_error.className = 'field-error';
                    } else {
                        showError(field, field_error, '', form_id, field_name);
                    }

                    if (compareField != '') {
                        if (compareField.value != field.value) {
                            showError(field, field_error, 'passwordConfirmFails', form_id, field_name);
                        }
                    }
                }

                field.addEventListener('input', inputListeningFn);
            }, {
                once: true
            });
        }
    }
};